import products from './products'
import customers from './customers'
import orders from './orders'

// products → V2 (managed in the V3 manager, read via the public router).
// orders / customers → V1 (the live document-request flow; kept on the working
// legacy account — they need auth and are unverified against the V2 account).
export default function (v2, v1) {
  return {
    orders: orders(v1),
    customers: customers(v1),
    products: products(v2),
  }
}
